import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { initTelemetry } from './telemetry';
import AppRouter from './AppRouter';
import { logAppInfo } from './services/LoggerService';
import './index.css';

initTelemetry();

// Log de informações da aplicação e endpoints dos serviços
logAppInfo();

const rootElement = document.getElementById('root')!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <AppRouter />
    </I18nextProvider>
  </React.StrictMode>,
);
